"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Routes_1 = require("../../../constants/Routes");
var react_i18next_1 = require("react-i18next");
var TermsPolicyLinks_1 = __importDefault(require("../TermsPolicyLinks"));
var formik_1 = require("formik");
var newsletterSubscriptionSchema_1 = __importDefault(require("../../../schemas/newsletterSubscriptionSchema"));
var Validation_1 = __importDefault(require("../../Validation"));
var Button_1 = __importDefault(require("../../Button"));
var newsletterSubscriptionSlice_1 = require("../../../features/newsletterSubscription/newsletterSubscriptionSlice");
var globalSlice_1 = require("../../../features/global/globalSlice");
var react_redux_1 = require("react-redux");
var Localization_1 = require("../../../constants/Localization");
var i18n_1 = __importDefault(require("../../../i18n"));
var WidgetList = function (_a) {
    var isSubscriptionWidget = _a.isSubscriptionWidget;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var handleNewsletterSubscription = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(newsletterSubscriptionSlice_1.newsletterSubscribe(values.newsletterSubscription))];
                case 1:
                    _a.sent();
                    dispatch(globalSlice_1.addToastMessage({
                        text: t('FOOTER.NEWSLETTER_SUCCESS'),
                        appearance: 'success',
                    }));
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    if (e_1.response.status === 422) {
                        if (e_1.response.data.errors.email) {
                            dispatch(globalSlice_1.addToastMessage({
                                text: t(e_1.response.data.errors.email),
                                appearance: 'error',
                            }));
                        }
                        else {
                            dispatch(globalSlice_1.addToastMessage({
                                text: t('FOOTER.NEWSLETTER_EXIST'),
                                appearance: 'error',
                            }));
                        }
                    }
                    else {
                        dispatch(globalSlice_1.addToastMessage({
                            text: t('FOOTER.NEWSLETTER_ERROR'),
                            appearance: 'error',
                        }));
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "footer-box-container" },
        react_1.default.createElement("div", { className: "footer-container" },
            react_1.default.createElement("div", { className: "widget-column" },
                react_1.default.createElement("div", { className: "col widget-menu" },
                    react_1.default.createElement("h4", null, t('main_pages')),
                    react_1.default.createElement("div", { className: "row" },
                        react_1.default.createElement("ul", null,
                            react_1.default.createElement("li", null,
                                react_1.default.createElement(react_router_dom_1.Link, { to: "/" + Localization_1.SellPagePrefix[i18n_1.default.language].sell }, t('HEADER.Menu.Buy'))),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement(react_router_dom_1.Link, { to: "/" + Localization_1.SellPagePrefix[i18n_1.default.language].rent },
                                    t('HEADER.Menu.Rent'),
                                    ' ')),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement(react_router_dom_1.Link, { to: Routes_1.Routes.ContactUs.path }, t('contact_us'))),
                            react_1.default.createElement("li", null,
                                react_1.default.createElement(react_router_dom_1.Link, { to: Routes_1.Routes.AboutUs.path }, t('about'))))))),
            react_1.default.createElement("div", { className: "widget-column" },
                react_1.default.createElement("div", { className: "col widget-menu terms-conditions-widget" },
                    react_1.default.createElement("h4", null, t('FOOTER.SETTINGS')),
                    react_1.default.createElement(TermsPolicyLinks_1.default, null))),
            isSubscriptionWidget && (react_1.default.createElement("div", { className: "widget-column" },
                react_1.default.createElement("div", { className: "col widget-subscription" },
                    react_1.default.createElement("h4", null, t('subscription.SUBSCRIBE')),
                    react_1.default.createElement(formik_1.Formik, { initialValues: {
                            newsletterSubscription: '',
                        }, validationSchema: newsletterSubscriptionSchema_1.default, onSubmit: function (values) {
                            return handleNewsletterSubscription(values);
                        }, validateOnBlur: false }, function (formik) { return (react_1.default.createElement(formik_1.Form, { className: "subscription-box" },
                        react_1.default.createElement("div", { className: 'validation-form-group' },
                            react_1.default.createElement(Validation_1.default, { name: "newsletterSubscription", formikProps: formik },
                                react_1.default.createElement("input", __assign({ placeholder: t('FOOTER.ENTER_EMAIL_ADDRESS'), autoComplete: "off" }, formik.getFieldProps('newsletterSubscription'), { onChange: function (e) {
                                        if (e.target.value ===
                                            ' ')
                                            return;
                                        formik.setFieldValue('newsletterSubscription', e.target.value
                                            .toLowerCase()
                                            .trim());
                                    } })))),
                        react_1.default.createElement(Button_1.default, { type: "submit", disabled: !formik.isValid ||
                                !formik.values['newsletterSubscription'] },
                            react_1.default.createElement("i", { className: "cm-icon icon-email" })))); })))))));
};
exports.default = WidgetList;
